import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CommunicationsStateService {
  private singleQuestSubject = new Subject<any>();
  private newQuestSubject = new Subject<any>();
  private reloadChatsSubject = new Subject<any>();
  private mobileClassQuestSubject = new Subject<any>();

  constructor() { }

  triggerSingleQuest(data) {
    this.singleQuestSubject.next(data);
  }

  handleSingleQuest(): Observable<any> {
    return this.singleQuestSubject.asObservable();
  }

  triggerNewQuest(data) {
    this.newQuestSubject.next(data);
  }

  handleNewQuest(): Observable<any> {
    return this.newQuestSubject.asObservable();
  }

  triggerReloadData(data) {
    this.reloadChatsSubject.next(data);
  }

  handleReloadData(): Observable<any> {
    return this.reloadChatsSubject.asObservable();
  }

  triggerSetMobileClass(data) {
    this.mobileClassQuestSubject.next(data);
  }

  handleSetMobileClass(): Observable<any> {
    return this.mobileClassQuestSubject.asObservable();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/communications.state.service.ts